class MapMyIndiaInit {
    constructor() {
        this.map = window.MapmyIndia.Map;
        this.marker = window.L.Marker;
        this.icon = window.L.icon;
        this.popup = window.L.popup;
        // this.infoWindow = window.google.maps.InfoWindow;
    }

    getMap() {
        return this.map;
    }

    getMarker() {
        return this.marker;
    }

    getIcon() {
        return this.icon;
    }

    getPopup() {
        return this.popup;
    }

    // getInfoWindow() {
    //     return this.infoWindow;
    // }
}

export default MapMyIndiaInit;
